import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';

const OInput = ({
  label,
  id,
  type,
  name,
  value,
  handleChange,
  style,
  disabled,
  errorMessage,
  touched,
  setTouched,
  step,
  onBlur,
  pattern,
  readonly,
  onEnter,
}) => {
  const inputRef = useRef(null);
  const handleClick = (event) => {
    if (type === 'number') {
      event.target.select(); // Selektujemo tekst kada se klikne na input polje
    }
  };
  const handleClickFocusInput = () => {
    inputRef.current.focus();
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && onEnter) {
      onEnter(event);
    }
  };
  return (
    <div style={{ ...style }}>
      <div
        className={`input_container ${
          touched && value?.length === 0 ? 'invalid' : ''
        }`}
        onClick={handleClickFocusInput}
        style={{
          backgroundColor: readonly ? '#f0f0f0' : 'initial', // Siva pozadina kada je readonly true
        }}
      >
        <label
          htmlFor={id}
          style={
            value?.length !== 0 || type === 'date'
              ? {
                  transform: 'translate(-15px, -7px) scale(0.8)',
                  backgroundColor: 'white',
                  padding: ' 0px 3px',
                }
              : {}
          }
        >
          {label}
        </label>
        <div style={{ display: 'grid' }}>
          <DebounceInput
            className="input_text"
            id={id}
            pattern={pattern}
            type={type}
            name={name}
            //  style={style}
            autoComplete="off"
            value={value || ''}
            onBlur={
              setTouched !== undefined
                ? () => setTouched(true)
                : onBlur !== undefined
                ? onBlur
                : () => {}
            }
            onChange={handleChange}
            debounceTimeout={300}
            disabled={disabled}
            step={step}
            onClick={handleClick}
            readOnly={readonly}
            inputRef={inputRef}
            onKeyDown={handleKeyDown}
            style={{
              backgroundColor: readonly ? '#f0f0f0' : 'initial', // Siva pozadina kada je readonly true
            }}
          />
        </div>
      </div>
      {touched && value?.length === 0 && (
        <span className="error-message">{errorMessage}</span>
      )}
    </div>
  );
};

export default React.memo(OInput);

OInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  touched: PropTypes.bool,
  setTouched: PropTypes.func,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
};
